export const config = {
  rowSelection: false,
  columns: [
    { title: '模板ID', dataIndex: 'id', width: 200 },
    { title: '模板名称', dataIndex: 'modelName', width: 250, ellipsis: true },
    { title: '备注', dataIndex: 'remarks', width: 250, ellipsis: true },
    { title: '状态', dataIndex: 'enabled', width: 90, fixed: 'right', render: 'switchRender' },
    { title: '操作', dataIndex: '#', width: 140, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    { label: '名称', name: 'nameKeyword' },
    {
      label: '模板ID',
      name: 'id',
      labelProps: { width: 58 },
      itemType: 'custom',
      render: 'numberRender',
    },
    // { label: '模板名称', name: 'modelNameLike' },
  ],
  footer: [{ label: '新增', type: 'primary', events: ['onClick:onAdd'] }],
}
